import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate } from "react-router-dom";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import { YurticiCargoService } from "../../../services/YurticiCargoService";
import { GetYurticiCargoListResponse, GetYurticiCargoListResponseData, GetYurticiCargoListResponseYurticiCargoExpectedIncomeOutcome } from "../../../models/response/yurticiCargo/GetYurticiCargoListResponse";
import CustomSwitch from "../../../components/CustomSwitch";
import Orders from "./Components/Orders";
import { YurticiCargoFindPriceRequest } from "../../../models/request/yurticiCargo/YurticiCargoFindPriceRequest";
import Prices from "./Components/Prices";

const YurticiCargoFindPrice = () => {
    const navigate = useNavigate();
    const pageName = "Kargo Modülü > Yurtiçi Kargo > Toplu Fiyat Bulma"
    const dispatch = useDispatch();

    const [mainData, setMainData] = useState<GetYurticiCargoListResponseData[]>([]);
    const [subData, setSubData] = useState<GetYurticiCargoListResponseYurticiCargoExpectedIncomeOutcome[]>([]);
    const [isIncome, setIsIncome] = useState(true);
    const [isOutcome, setIsOutcome] = useState(false);

    useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        try {
            var str = localStorage.getItem("SelectedIds");
            localStorage.removeItem("SelectedIds");

            if (str) {
                var ids: string[] = JSON.parse(str);

                if (ids && ids.length > 0) {
                    dispatch(storeActivityIndicator(true));

                    var response: GetYurticiCargoListResponse = await YurticiCargoService.getYurticiCargoList(ids);

                    if (!response.isSuccess) {
                        toast.error(response.message)
                        return;
                    }

                    response.data = response.data.map(function (x) {
                        x.yurticiCargoExpectedIncomeOutcomes = x.yurticiCargoExpectedIncomeOutcomes.filter(x => !x.invoiceId);
                        return x;
                    })

                    setMainData(response.data);
                }
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const findPrice = async () => {
        var selectedItems = mainData.filter(x => x.isSelected);

        if (selectedItems.length == 0) {
            toast.error("En az bir sipariş seçiniz!");
            return
        }

        try {
            dispatch(storeActivityIndicator(true));

            var obj: YurticiCargoFindPriceRequest = {
                isIncome: isIncome,
                isTemp: true,
                details: selectedItems.map(function (x) {
                    return { yurticiCargoId: x.yurticiCargoId }
                })
            }

            var response: GetYurticiCargoListResponse = await YurticiCargoService.yurticiCargoFindPrice(obj);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false));
                return;
            }

            response.data = response.data.map(function (a) {
                a.yurticiCargoExpectedIncomeOutcomes = a.yurticiCargoExpectedIncomeOutcomes.filter(x => x.agreementSchemeId && (x.totalPrice ?? 0) > 0).map(function (x) {
                    x.uniqueId = x.yurticiCargoId + "-" + x.agreementSchemeId;
                    x.refNo = a.refNo;
                    return x;
                })

                return a;
            })

            response.data = response.data.filter(x => x.yurticiCargoExpectedIncomeOutcomes.length > 0);

            setSubData(response.data.flatMap(x => x.yurticiCargoExpectedIncomeOutcomes));

            dispatch(storeActivityIndicator(false));
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const savePrice = async () => {
        var selectedItems = subData.filter(x => x.isSelected);

        if (selectedItems.length == 0) {
            toast.error("En az bir fiyat seçiniz!");
            return
        }

        try {
            dispatch(storeActivityIndicator(true));

            var obj: YurticiCargoFindPriceRequest = {
                isIncome: isIncome,
                isTemp: false,
                details: selectedItems.map(function (x) {
                    return {
                        yurticiCargoId: x.yurticiCargoId,
                        agreementSchemeId: x.agreementSchemeId
                    }
                })
            }

            var response: GetYurticiCargoListResponse = await YurticiCargoService.yurticiCargoFindPrice(obj);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false));
                return;
            }

            dispatch(storeActivityIndicator(false));

            toast.success("İşlem başarılı.");
            navigate('/yurticicargo/list');
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <KTCard className="ebbe-card">
                        <KTCardBody>
                            <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                            <div className="row">
                                <div className="col-md-4">
                                    <Box flexDirection={"row"}>
                                        <Box flex={1} justifyContent="center">
                                            <CustomSwitch
                                                labelText="Gelir"
                                                isLabelRequired
                                                isActive={isIncome}
                                                setIsActive={() => {
                                                    setIsIncome(!isIncome);
                                                    setIsOutcome(!isOutcome);
                                                }}
                                            />
                                        </Box>
                                        <Box flex={1} justifyContent="center">
                                            <CustomSwitch
                                                labelText="Gider"
                                                isLabelRequired
                                                isActive={isOutcome}
                                                setIsActive={() => {
                                                    setIsIncome(!isIncome);
                                                    setIsOutcome(!isOutcome);
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                </div>
                            </div>
                        </KTCardBody>
                    </KTCard>

                    <Orders
                        data={mainData}
                        findPrice={findPrice}
                        setData={setMainData}
                    />

                    {
                        subData.length > 0 && (
                            <Prices
                                data={subData}
                                setData={setSubData}
                            />
                        )
                    }

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">
                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate('/yurticicargo/list')}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={savePrice}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default YurticiCargoFindPrice;